import { Info } from 'lucide-react'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/shadcn/tooltip'

/** Small `i` icon that surfaces an explanation on hover/focus. Wrap any
 *  unfamiliar label with this rather than burying the meaning in the page. */
export function InfoTooltip({
  children,
  side = 'top',
}: {
  children: React.ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
}) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="text-muted-foreground/60 hover:text-muted-foreground inline-flex items-center transition-colors"
            aria-label="More information">
            <Info size={12} />
          </button>
        </TooltipTrigger>
        <TooltipContent side={side} className="max-w-xs">
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

/** Wraps a text label so hovering it reveals more context. Use for terms like
 *  "baseline" or "low confidence" that need a sentence of explanation. */
export function HintLabel({
  children,
  hint,
  className,
}: {
  children: React.ReactNode
  hint: React.ReactNode
  className?: string
}) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`decoration-muted-foreground/30 cursor-help underline decoration-dotted underline-offset-2 ${className ?? ''}`}>
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">{hint}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
